module.exports = __webpack_public_path__ + "static/media/Eclipse-1.5s-200px.4011948f.gif";